import { NamespacedImageKeys } from '@betty/moonlight';
import {
  StatusType,
  StatusTextTokens,
  StatusSolidTextTokens,
  StatusBackgroundTokens,
} from '../state/status.types';

export const statusTextTokenMap: Record<StatusType, StatusTextTokens> = {
  Member: 'darkSurfaceStatusMember',
  Amethyst: 'darkSurfaceStatusAmethyst',
  Topaz: 'darkSurfaceStatusTopaz',
  Aquamarine: 'darkSurfaceStatusAquamarine',
  Opal: 'darkSurfaceStatusOpal',
  Emerald: 'darkSurfaceStatusEmerald',
  Ruby: 'darkSurfaceStatusRuby',
  Sapphire: 'darkSurfaceStatusSapphire',
  Diamond: 'darkSurfaceStatusDiamond',
  Vip: 'darkSurfaceStatusVip',
};

export const statusSolidTextTokenMap: Record<
  StatusType,
  StatusSolidTextTokens
> = {
  Member: 'darkSurfaceSolidStatusMember',
  Amethyst: 'darkSurfaceSolidStatusAmethyst',
  Topaz: 'darkSurfaceSolidStatusTopaz',
  Aquamarine: 'darkSurfaceSolidStatusAquamarine',
  Opal: 'darkSurfaceSolidStatusOpal',
  Emerald: 'darkSurfaceSolidStatusEmerald',
  Ruby: 'darkSurfaceSolidStatusRuby',
  Sapphire: 'darkSurfaceSolidStatusSapphire',
  Diamond: 'darkSurfaceSolidStatusDiamond',
  Vip: 'darkSurfaceSolidStatusVip',
};

export const statusBackgroundTokenMap: Record<
  StatusType,
  StatusBackgroundTokens
> = {
  Member: 'statusMemberBackground',
  Amethyst: 'statusAmethystBackground',
  Topaz: 'statusTopazBackground',
  Aquamarine: 'statusAquamarineBackground',
  Opal: 'statusOpalBackground',
  Emerald: 'statusEmeraldBackground',
  Ruby: 'statusRubyBackground',
  Sapphire: 'statusSapphireBackground',
  Diamond: 'statusDiamondBackground',
  Vip: 'statusVipBackground',
};

export const statusBadgeMap: Partial<Record<StatusType, NamespacedImageKeys>> =
  {
    Member: 'status.AmethystLockedBadge',
    Amethyst: 'status.AmethystBadge',
    Topaz: 'status.TopazBadge',
    Aquamarine: 'status.AquamarineBadge',
    Opal: 'status.OpalBadge',
    Emerald: 'status.EmeraldBadge',
    Ruby: 'status.RubyBadge',
    Sapphire: 'status.SapphireBadge',
    Diamond: 'status.DiamondBadge',
    Vip: 'status.VipBadge',
  };

export const statusGemMap: Partial<Record<StatusType, NamespacedImageKeys>> = {
  Amethyst: 'status.AmethystGem',
  Topaz: 'status.TopazGem',
  Aquamarine: 'status.AquamarineGem',
  Opal: 'status.OpalGem',
  Emerald: 'status.EmeraldGem',
  Ruby: 'status.RubyGem',
  Sapphire: 'status.SapphireGem',
  Diamond: 'status.DiamondGem',
  Vip: 'status.VipGem',
};
